var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "用户信息",
        visible: _vm.dialogVisible,
        width: "500px",
        "append-to-body": "",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formLabelAlign",
          attrs: {
            "label-position": "right",
            "label-width": "140px",
            model: _vm.formData,
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "oldPass",
              attrs: { label: "账号：", prop: "oldPass" },
            },
            [_c("span", [_vm._v(_vm._s(_vm.user.username))])]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "oldPass",
              attrs: { label: "姓名：", prop: "oldPass" },
            },
            [_c("span", [_vm._v(_vm._s(_vm.user.realName))])]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "oldPass",
              attrs: { label: "手机号：", prop: "oldPass" },
            },
            [_c("span", [_vm._v(_vm._s(_vm.user.phone))])]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "oldPass",
              attrs: { label: "角色列表：", prop: "oldPass" },
            },
            [
              _vm.user.roles
                ? _c(
                    "div",
                    _vm._l(_vm.user.roles, function (item) {
                      return _c(
                        "el-tag",
                        {
                          key: item.id,
                          staticStyle: { "margin-right": "5px" },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }